/**
 * Helper function to detect small screens
 */
export default function isSmallScreen() {
  return window.innerWidth <= 800 || window.innerHeight <= 600;
}
